var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.project.id)?_c('task-modal',{attrs:{"availableProject":_vm.project,"hasProject":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }